export default {
      id: "log_in-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#log_in",
      toString: function () {
        return this.url;
      }
    }